export default __webpack_public_path__ + "static/media/portfoliomcc.f249c361.png";